import RolesConfigurationType from 'store/actionTypes/rolesConfiguration'

const initialData = {
  list: [],
  allowedRoleManage: []
}

const rolesConfiguration = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case RolesConfigurationType.GET_ROLES_CONFIGURATION_SUCCESS:
      return { ...state, list: payload?.items }
    case RolesConfigurationType.GET_ALLOWED_ROLE_MANAGE_SUCCESS:
      return { ...state, allowedRoleManage: payload?.items }
    default:
      return state
  }
}

export default rolesConfiguration
